import React, { lazy, Suspense } from "react";
import TablePagesTitle from "../../components/table-pages-title/TablePagesTitle";
import LoginAsUser from "../../components/loginasuser/LoginAsUser";
import { commonText, emailTemplate } from "../../locales/en";
import ComponentViewFallback from "../../components/error-boundary/fallback/ComponentViewFallback";
import ErrorBoundary from "../../components/error-boundary";

const EmailTemplateTable = lazy(
  () =>
    import(
      "../../components/table/all-tables/emailtemplatetable/EmailTemplateTable"
    )
);

export default function EmailTemplate() {
  return (
    <>
      <LoginAsUser />
      <TablePagesTitle mainTitle={emailTemplate.mainTitle} />
      <ErrorBoundary fallback={<ComponentViewFallback />}>
        <div className="row mt-4 mb-2 mx-0 ">
          <div className="col-md-12 px-0">
            <Suspense fallback={<div>{commonText.fallbackLoader}</div>}>
              <EmailTemplateTable />
            </Suspense>
          </div>
        </div>
      </ErrorBoundary>
    </>
  );
}
